export default {
  title: {
    en: '{count, plural, one {month} other {months}}',
  },
}
